import { useLayoutEffect, useState, type RefObject } from "react"

const CARD_WIDTH = 220
export const CARD_GAP = 12

const getColumnCount = (width: number) => {
  return Math.max(1, Math.round((width + CARD_GAP) / (CARD_WIDTH + CARD_GAP)))
}

export const useInspirationColumnCount = (
  ref: RefObject<HTMLElement | null>,
) => {
  const [columnCount, setColumnCount] = useState(1)

  useLayoutEffect(() => {
    const element = ref.current
    if (!element) return

    setColumnCount(getColumnCount(element.getBoundingClientRect().width))
    const observer = new ResizeObserver(([entry]) => {
      if (entry) setColumnCount(getColumnCount(entry.contentRect.width))
    })
    observer.observe(element)

    return () => {
      observer.disconnect()
    }
  }, [ref])

  return columnCount
}
